import React, { useEffect, useState } from "react";
import {
    TextField,
    Button,
    Grid,
    MenuItem,
    Box,
    CircularProgress,
    IconButton,
    Snackbar,
    Alert,
    Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { vendorApi } from "../../../api/api";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const EditApartmentPlotsDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const property = location.state?.property;
    console.log(property);
    // debugger
    const [loading, setLoading] = useState(false);
    const [successOpen, setSuccessOpen] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [errorOpen, setErrorOpen] = useState(false);
    const [iconFile, setIconFile] = useState(null);
    const [form, setForm] = useState({
        name: "",
        city: "",
        address: "",
        LandArea: "",
        TotalFloors: "",
        TotalBlocks: "",
        TotalUnits: "",
        Construction_Status: "",
        Description: "",
    });

    const [commissionType, setCommissionType] = useState("percentage");
    const [commissionValue, setCommissionValue] = useState("");
    const [amenities, setAmenities] = useState([{ name: "" }]);

    /* ================= LOAD DATA ================= */
    useEffect(() => {
        if (!property) return;

        setForm({
            name: property.name || "",
            city: property.city || "",
            address: property.address || "",
            LandArea: property.LandArea || "",
            TotalFloors: property.TotalFloors || "",
            TotalBlocks: property.TotalBlocks || "",
            TotalUnits: property.TotalUnits || "",
            Construction_Status: property.Construction_Status || "",
            Description: property.Description || "",
        });

        if (property.PercentageAmount) {
            setCommissionType("percentage");
            setCommissionValue(property.PercentageAmount);
        } else if (property.SqftAmount) {
            setCommissionType("sqft");
            setCommissionValue(property.SqftAmount);
        }

        try {
            const parsedAmenities = JSON.parse(property.Amenities || "[]");
            setAmenities(parsedAmenities.length ? parsedAmenities : [{ name: "" }]);
        } catch {
            setAmenities([{ name: "" }]);
        }
    }, [property]);

    /* ================= HANDLERS ================= */
    const handleChange = (e) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    const handleAmenityChange = (index, value) => {
        const updated = [...amenities];
        updated[index].name = value;
        setAmenities(updated);
    };

    const addAmenity = () => setAmenities([...amenities, { name: "" }]);
    const removeAmenity = (index) =>
        setAmenities(amenities.filter((_, i) => i !== index));

    /* ================= UPDATE ================= */
    const updateApartment = async () => {
        try {
            setLoading(true);

            const fd = new FormData();

            fd.append("Id", property.id);
            fd.append("ApartmentName", form.name);
            fd.append("City", form.city);
            fd.append("Address", form.address);
            fd.append("Description", form.Description);
            fd.append("LandArea", form.LandArea);
            fd.append("TotalFloors", form.TotalFloors);
            fd.append("TotalUnits", form.TotalUnits);
            fd.append("TotalBlocks", form.TotalBlocks);
            fd.append("Construction_Status", form.Construction_Status);

            if (commissionType === "percentage") {
                fd.append("PercentageAmount", commissionValue);
                fd.append("SqftAmount", "");
            } else {
                fd.append("PercentageAmount", "");
                fd.append("SqftAmount", commissionValue);
            }

            const cleanAmenities = amenities
                .filter((a) => a.name && a.name.trim() !== "")
                .map((a) => ({ name: a.name.trim() }));

            fd.append("Amenities", JSON.stringify(cleanAmenities));

            console.log("Property ID:", property.id);

            for (let [key, value] of fd.entries()) {
                console.log(key, value);
            }

            debugger;
            const res = await vendorApi.editApartmentDetails(fd);
            debugger
            if (res.data.status === "success") {
                setSuccessOpen(true);

                setTimeout(() => {
                    navigate(-1);
                }, 1500);
            } else {
                setErrorMsg(res.data.message || "Something went wrong");
                setErrorOpen(true);
            }

        } catch (err) {
            setErrorMsg(
                err.response?.data?.message || "Server error. Please try again."
            );
            setErrorOpen(true);
        } finally {
            setLoading(false);
        }
    };



    if (!property) return <Typography>No data found</Typography>;

    /* ================= UI ================= */
    return (
        <Box p={3} maxWidth={1000} mx="auto" mt={2}>
            <Box display="flex" alignItems="center" gap={1} mb={3}>
                <IconButton onClick={() => navigate(-1)}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h5">
                    Edit Apartment Details
                </Typography>
            </Box>

            {loading ? (
                <Box textAlign="center">
                    <CircularProgress />
                </Box>
            ) : (
                <Grid container spacing={2}>
                    {/* Row 1 */}
                    <Grid item xs={12} md={6} sx={{
                        width: {
                            xs: "100%",
                            sm: "45%",
                            lg: "45%"
                        }
                    }}>
                        <TextField
                            fullWidth
                            label="Apartment Name"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} sx={{
                        width: {
                            xs: "100%",
                            sm: "45%",
                            lg: "45%"
                        }
                    }}>
                        <TextField
                            fullWidth
                            label="City"
                            name="city"
                            value={form.city}
                            onChange={handleChange}
                        />
                    </Grid>

                    {/* Row 2 */}
                    <Grid item xs={12} md={6} sx={{
                        width: {
                            xs: "100%",
                            sm: "45%",
                            lg: "45%"
                        }
                    }}>
                        <TextField
                            fullWidth
                            label="Land Area"
                            name="LandArea"
                            value={form.LandArea}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} sx={{
                        width: {
                            xs: "100%",
                            sm: "45%",
                            lg: "45%"
                        }
                    }}>
                        <TextField
                            fullWidth
                            label="Address"
                            name="address"
                            value={form.address}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} sx={{
                        width: {
                            xs: "100%",
                            sm: "45%",
                            lg: "45%"
                        }
                    }}>
                        <TextField
                            fullWidth
                            label="Total Floors"
                            name="TotalFloors"
                            value={form.TotalFloors}
                            onChange={handleChange}
                        />
                    </Grid>

                    {/* Row 3 */}
                    <Grid item xs={12} md={6} sx={{
                        width: {
                            xs: "100%",
                            sm: "45%",
                            lg: "45%"
                        }
                    }}>
                        <TextField
                            fullWidth
                            label="Total Blocks"
                            name="TotalBlocks"
                            value={form.TotalBlocks}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} sx={{
                        width: {
                            xs: "100%",
                            sm: "45%",
                            lg: "45%"
                        }
                    }}>
                        <TextField
                            fullWidth
                            label="Total Flats"
                            name="TotalUnits"
                            value={form.TotalUnits}
                            onChange={handleChange}
                        />
                    </Grid>

                    {/* Row 4 */}
                    <Grid item xs={12} md={6} sx={{
                        width: {
                            xs: "100%",
                            sm: "45%",
                            lg: "45%"
                        }
                    }}>
                        <TextField
                            select
                            fullWidth
                            label="Construction Status"
                            name="Construction_Status"
                            value={form.Construction_Status}
                            onChange={handleChange}
                        >

                            <MenuItem value="Planning">Planning</MenuItem>
                            <MenuItem value="Under Construction">
                                Under Construction
                            </MenuItem>
                            <MenuItem value="Ready to Move">Ready to Move</MenuItem></TextField>
                    </Grid>


                    {/* Row 5 */}
                    <Grid item xs={12} md={6} sx={{
                        width: {
                            xs: "100%",
                            sm: "45%",
                            lg: "45%"
                        }
                    }}>
                        <TextField
                            select
                            fullWidth
                            label="Commission Type"
                            value={commissionType}
                            onChange={(e) => {
                                setCommissionType(e.target.value);
                                setCommissionValue("");
                            }}
                        >

                            <MenuItem value="percentage">Percentage (%)</MenuItem>
                            <MenuItem value="sqft">Per Sqft</MenuItem></TextField>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{
                        width: {
                            xs: "100%",
                            sm: "45%",
                            lg: "45%"
                        }
                    }}>
                        <TextField
                            fullWidth
                            type="number"
                            label={
                                commissionType === "percentage"
                                    ? "Percentage Amount"
                                    : "Sqft Amount"
                            }
                            value={commissionValue}
                            onChange={(e) => setCommissionValue(e.target.value)}
                        />
                    </Grid>

                    {/* Row 6 */}
                    <Grid item xs={12} md={6} sx={{
                        width: {
                            xs: "100%",
                            sm: "91%",
                            lg: "91%"
                        }
                    }}>
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            label="Description"
                            name="Description"
                            value={form.Description}
                            onChange={handleChange}
                        />
                    </Grid>

                    {/* Amenities – always 2 per row */}
                    {amenities.map((a, i) => (
                        <Grid item xs={12} md={6} key={i}>
                            <Box display="flex" gap={1}>
                                <TextField
                                    fullWidth
                                    label={`Amenity ${i + 1}`}
                                    value={a.name}
                                    onChange={(e) => handleAmenityChange(i, e.target.value)}
                                    sx={{ width: "100%" }}
                                />
                                {amenities.length > 1 && (
                                    <IconButton
                                        color="error"
                                        onClick={() => removeAmenity(i)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                )}
                            </Box>
                        </Grid>
                    ))}

                    <Grid item xs={12} md={6}>
                        <Button onClick={addAmenity}>+ Add Amenity</Button>
                    </Grid>

                    {/* Actions */}
                    <Grid

                        item
                        xs={12}

                        gap={2}
                        mt={4}
                        sx={{
                            width: "91%", display: "flex",
                            justifyContent: "flex-end"
                        }}
                    >
                        <Button variant="outlined" onClick={() => navigate(-1)}>
                            Cancel
                        </Button>
                        <Button variant="contained" onClick={updateApartment}>
                            Update Apartment
                        </Button>
                    </Grid>

                </Grid>
            )}

            <Snackbar
                open={successOpen}
                autoHideDuration={3000}
                onClose={() => setSuccessOpen(false)}
            >
                <Alert severity="success">Apartment updated successfully!</Alert>
            </Snackbar>
            <Snackbar
                open={errorOpen}
                autoHideDuration={3000}
                onClose={() => setErrorOpen(false)}
            >
                <Alert severity="error">
                    {errorMsg}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default EditApartmentPlotsDetails;